import http from './base.js'

export default {
  subscribe(params) {
    return http.post('/raysync_email_subscribe/add', params)
  },
}
